<div class="container">
  <app-generic-field [label]="labelStart"  [hideLabel]="hideLabel">
    <div class="content">
      <p-calendar
        #min [panelStyle]="{transform: 'translateY(100px)'}"
        [(ngModel)]="start"
        [disabled]="disabled"
        appendTo="body"
        (onSelect)="startDateSelect($event)"
        (onBlur)="dateHandler()"
        class="col-6 p-nogutter">
        <ng-template pTemplate="footer">
          <div>
            <div class="option-box">
              <div class="option"
                   (click)="onOptionClick(i, min)"
                   *ngFor="let option of commonOptions; let i = index"
              >
                {{option.title}}
              </div>
            </div>
          </div>
        </ng-template>
      </p-calendar>
    </div>
  </app-generic-field>

  <app-generic-field [label]="labelEnd" [hideLabel]="hideLabel">
    <div class="content">
      <p-calendar
        #max [panelStyle]="{transform: 'translateY(100px)'}"
        [(ngModel)]="end"
        [disabled]="disabled"
        (onSelect)="setMaxBetweenDate(); endDateSelect($event)"
        (onBlur)="dateHandler()"
        appendTo="body"
        class="col-6 p-nogutter">
        <ng-template pTemplate="footer">
          <div class="option"
               (click)="onOptionClick(i, max)"
               *ngFor="let option of commonOptions; let i = index"
          >
            {{option.title}}
          </div>
        </ng-template>
      </p-calendar>

    </div>
  </app-generic-field>
</div>
